import gsap from "gsap";
import SplitText from "gsap/SplitText";

export default class Project {
  constructor(container) {
    this.container = container;
    this.buttons = this.container.querySelectorAll(".project__button");
    this.prevButton = this.buttons[0];
    this.nextButton = this.buttons[1];

    // On stocke les références pour le nettoyage
    this.onPrevEnter = this.handleEnter.bind(this, "prev");
    this.onNextEnter = this.handleEnter.bind(this, "next");

    this.init();
  }

  init() {
    if (!this.prevButton || !this.nextButton) return;

    // On attend que les polices soient chargées
    document.fonts.ready.then(() => {
      // Préparation du bouton PREV
      this.prevData = this.prepareButton(this.prevButton);
      this.prevTimeline = this.createTimeline(
        this.prevData.originalChars,
        this.prevData.clonedChars
      );
      // Préparation du bouton NEXT
      this.nextData = this.prepareButton(this.nextButton);
      this.nextTimeline = this.createTimeline(
        this.nextData.originalChars,
        this.nextData.clonedChars
      );

      this.initEventsListeners();
    });
  }

  prepareButton(button) {
    const originalContent = button.innerHTML;
    const originalWrapper = document.createElement("div");
    originalWrapper.innerHTML = originalContent;
    originalWrapper.classList.add("project__button-original");

    const clonedWrapper = document.createElement("div");
    clonedWrapper.innerHTML = originalContent;
    clonedWrapper.classList.add("project__button-clone");

    button.innerHTML = "";
    button.appendChild(originalWrapper);
    button.appendChild(clonedWrapper);

    gsap.set(button, { position: "relative", overflow: "hidden" });
    gsap.set(originalWrapper, { position: "relative" });
    gsap.set(clonedWrapper, {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    });

    const originalSplit = SplitText.create(originalWrapper, { type: "chars" });
    const clonedSplit = SplitText.create(clonedWrapper, { type: "chars" });

    gsap.set(clonedSplit.chars, { yPercent: 100 });

    return {
      button,
      originalSplit,
      clonedSplit,
      originalChars: originalSplit.chars,
      clonedChars: clonedSplit.chars,
    };
  }

  createTimeline(originalChars, clonedChars) {
    const duration = 0.5;
    const stagger = 0.05;
    const tl = gsap.timeline({ paused: true });

    tl.to(
      originalChars,
      {
        yPercent: -100,
        stagger: stagger,
        duration: duration,
        ease: "back.out",
      },
      0
    ).to(
      clonedChars,
      {
        yPercent: 0,
        stagger: stagger,
        duration: duration,
        ease: "back.out",
      },
      0
    );

    return tl;
  }

  initEventsListeners() {
    this.prevButton.addEventListener("mouseenter", this.onPrevEnter);

    this.nextButton.addEventListener("mouseenter", this.onNextEnter);
  }

  // --- Gestion des événements ---
  handleEnter(type) {
    if (type === "prev") {
      this.prevTimeline.restart(); // <-- CHANGEMENT
    } else {
      this.nextTimeline.restart(); // <-- CHANGEMENT
    }
  }

  destroy() {
    if (this.prevButton) {
      this.prevButton.removeEventListener("mouseenter", this.onPrevEnter);
      this.prevButton.removeEventListener("mouseleave", this.onPrevLeave);
    }
    if (this.nextButton) {
      this.nextButton.removeEventListener("mouseenter", this.onNextEnter);
      this.nextButton.removeEventListener("mouseleave", this.onNextLeave);
    }

    if (this.prevTimeline) this.prevTimeline.kill();
    if (this.nextTimeline) this.nextTimeline.kill();

    if (this.prevData?.originalSplit) this.prevData.originalSplit.revert();
    if (this.prevData?.clonedSplit) this.prevData.clonedSplit.revert();
    if (this.nextData?.originalSplit) this.nextData.originalSplit.revert();
    if (this.nextData?.clonedSplit) this.nextData.clonedSplit.revert();
  }
}
